import { siteGroups } from "..";
const name = "MenuStickyTabs";
const variants = ["OldTabs", "NewStickyTabs"];
export const menuStickyTabs = {
    name,
    variants: [
        ["OldTabs", 4],
        ["NewStickyTabs", 1], // Test, ~20%
    ],
    controlVariant: variants[0],
    apply: (assignVariant, clearVariant, getVariant) => {
        const menuElement = document.querySelector(".restaurant-menu");
        const menuGroupElement = document.querySelector(".js-group");
        const menuGroupNavTopElement = document.querySelector(".m-flex-layout--column");
        // FIXME: this is a hack to allow to simply test field-test in e2e & QA
        const isTesting = localStorage.getItem("fieldTestExperimentsTest");
        const isProduction = Skubacz.configuration.environment === "production";
        const validCountry = Skubacz.configuration.country === "PL";
        const validSource = !Skubacz.Device.isMobileApp();
        const validSiteId = siteGroups.even(Skubacz.configuration.site_id);
        const validDOM = menuElement !== null &&
            menuGroupElement !== null &&
            menuGroupNavTopElement !== null;
        // e2e & testing purposes:
        if (isTesting && validDOM) {
            const testingVariant = getVariant();
            applyExperiment(testingVariant, menuElement, menuGroupElement);
            return;
        }
        // production conditions
        if (isProduction && validSource && validCountry && validSiteId) {
            // If on the Menu page with menuElements -> assign variant & apply variant
            // NOTICE: It is crucial to:
            // - not set the value on the other pages (where user cannot see the change)
            // - not reset the value on the other pages
            if (validDOM) {
                const variant = assignVariant();
                applyExperiment(variant, menuElement, menuGroupElement);
            }
        }
        else {
            clearVariant();
        }
    },
};
function applyExperiment(variant, menuElement, menuGroupElement) {
    switch (variant) {
        case "NewStickyTabs": {
            // Activate feature flag and reflect it's changes in the DOM from the liquid side
            Skubacz.configuration.feature_flags.sticky_nav = true;
            menuGroupElement.setAttribute("data-mode", "list-all");
            menuGroupElement.setAttribute("data-mode-mobile", "list-all");
            menuElement.classList.add("restaurant-menu--sticky-tabs-mobile", "restaurant-menu--sticky-tabs-desktop");
            break;
        }
        default: {
            // Control variant doesn't need any change
        }
    }
}
